import { render } from "./index.vue?vue&type=template&id=0d69b7a0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=0d69b7a0&scoped=true&lang=less"

import exportComponent from "F:\\project\\trade_lab_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d69b7a0"]])

export default __exports__